export default "__VITE_ASSET__32fb7058__"